/**
 * transforms/connectorPlane.ts — Connector plane frame (WRAPPER three.js).
 *
 * REVISED BOUNDARY RULE (SPEC §6, point 2): `transforms/` is the
 * wrapping on three.js. This function constructs the FRAME of the plan
 * connector (SPEC G1): plane parallel to Y-Z, normal along X, at height
 * `h` from the X-Z plane (grid y=0). It is the ROOT/ANCHOR of the world — the chain
 * kinematics arranges around it (FramePlane root).
 *
 * The frame is a THREE.Group already positioned in the world (position [0,h,0],
 * quaternion identity): frame composition occurs via HIERARCHY
 * native parent-child of three.js (no linear algebra by hand).*/

import * as THREE from "three";

/**
 * Constructs the connector plane frame at `height` (SPEC G1).
 *
 * The connector plane is parallel to Y-Z (normal along X), positioned at
 * y = height. It is the root of the kinematic chain: the children (pivot alphaDeg,
 * joist/header groups, beams) snap here with RELATIVE coordinates.
 *
 * @param height Height `h` of the connector plane from the X-Z plane (mm).
 * In v1 use the `CONNECTOR_PLANE_HEIGHT_MM` constant from config.
 * @returns THREE.Group already positioned (name "FramePlane").*/
export function createConnectorPlaneFrame(height: number): THREE.Group {
  const group = new THREE.Group();
  group.name = "FramePlane";
  group.position.set(0, height, 0);
  group.quaternion.identity();
  return group;
}
